import { useQuery } from '@tanstack/react-query';
import { getLeads } from 'api/leads';
import { queryClient } from 'react-query';
import { PaginatedData } from 'models/PaginatedData';
import { LeadApiResponse } from 'models/Lead';

type LeadsParams = {
  campaignId?: string;
  email?: string;
  page?: number;
  limit?: number;
  [key: string]: any;
};

const fetchLeads = async (params: LeadsParams) => {
  const path = getLeads();
  return queryClient.fetchQuery<PaginatedData<LeadApiResponse>>({
    queryKey: [path, params],
  });
};

const useSearchLeads = (params: LeadsParams) => {
  const hasSearch = !!params?.email?.trim();

  return useQuery({
    queryKey: ['leads-search', params], // queryKey depends on page & limit
    queryFn: () => fetchLeads(params),
    enabled: hasSearch,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true, // optional
    gcTime: 0,
  });
};

export default useSearchLeads;
